import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import Selector from '../../common/custom-selector';
import Icon from 'utils/components/icon';
import { YESTERDAY, LAST_WEEK, THIS_WEEK, LAST_MONTH, CUSTOM, THIS_MONTH } from '../models/period';
import { LazyDatePicker } from "app/scripts/components/common/LazyDatePicker";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);
dayjs.extend(utc);

function isInTooltip(node) {
  var dateNode = document.querySelector('.date-picker');
  var selectorNode = document.querySelector('.custom-selector');
  return (dateNode && dateNode.contains(node)) || (selectorNode && selectorNode.contains(node));
}

class DatesSelector extends Component {
  static displayName = 'DatesSelector';

  static propTypes = {
    pageInfo: PropTypes.object.isRequired,
    onFiltersChange: PropTypes.func
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    const {
      pageInfo: { fromDay, toDay }
    } = props;
    this.state = {
      disableApply: true,
      datePickerFromDay: dayjs(fromDay),
      datePickerToDay: dayjs(toDay)
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClicked.bind(this));
  }

  componentWillUnMount() {
    window.removeEventListener('click', this.onWindowClicked.bind(this));
  }

  onWindowClicked(event) {
    var tergetNode = null;
    if (event.target && event.target.className && typeof event.target.className === 'string') {
      tergetNode = document.querySelector(`.${event.target.className}`);
    }

    if (tergetNode && !isInTooltip(tergetNode) && this.refs.selector) {
      this.refs.selector.hide();
    }
  }

  onApply() {
    var { onFiltersChange } = this.props;
    const { datePickerFromDay, datePickerToDay } = this.state;
    onFiltersChange({
      period: CUSTOM,
      fromDay: datePickerFromDay.format('YYYY-MM-DD'),
      toDay: datePickerToDay.format('YYYY-MM-DD')
    });

    if (this.refs.selector) {
      this.refs.selector.hide();
    }
  }

  onChange(value) {
    var { onFiltersChange } = this.props;
    var toDay = dayjs().utc();
    var fromDay = dayjs().utc();
    if (this.refs.selector) {
      this.refs.selector.hide();
    }

    switch (value) {
      case YESTERDAY:
        fromDay = fromDay.subtract(1, 'day').startOf('day');
        toDay = toDay.subtract(1, 'day').endOf('day');
        break;
      case LAST_WEEK:
        fromDay = dayjs().subtract(1, 'week').startOf('isoWeek');
        toDay = dayjs().subtract(1, 'week').endOf('isoWeek');
        break;
      case THIS_WEEK:
        fromDay = dayjs().utc().startOf('isoweek');
        break;
      case THIS_MONTH:
        fromDay = dayjs().utc().startOf('month');
        break;
      case LAST_MONTH:
        fromDay = dayjs().utc().startOf('month');
        fromDay = fromDay.subtract(1, 'month');
        toDay = dayjs(fromDay).endOf('month');
        break;
      default:
        value = CUSTOM;
    }

    onFiltersChange({
      period: value,
      fromDay: fromDay.format('YYYY-MM-DD'),
      toDay: toDay.format('YYYY-MM-DD')
    });
  }

  handleFromChange(datePickerFromDay) {
    this.setState({ datePickerFromDay: dayjs(datePickerFromDay), disableApply: false });
  }

  handleToChange(datePickerToDay) {
    this.setState({ datePickerToDay: dayjs(datePickerToDay), disableApply: false });
  }

  isChecked(period) {
    const { pageInfo } = this.props;
    return pageInfo.period === period ? 'checked' : '';
  }

  render() {
    const { period } = this.props.pageInfo;
    const { disableApply, datePickerFromDay, datePickerToDay } = this.state;
    var customSelected = null;
    var fromMaxDate = datePickerToDay || dayjs().utc();
    var toMaxDate = dayjs().utc();
    var toMinDate = datePickerFromDay;

    var items = [
      {
        value: YESTERDAY,
        element: (
          <span onClick={this.onChange.bind(this, YESTERDAY)}>
            Yesterday
            {this.isChecked(YESTERDAY) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: THIS_WEEK,
        element: (
          <span onClick={this.onChange.bind(this, THIS_WEEK)}>
            This Week
            {this.isChecked(THIS_WEEK) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: LAST_WEEK,
        element: (
          <span onClick={this.onChange.bind(this, LAST_WEEK)}>
            Last Week
            {this.isChecked(LAST_WEEK) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: THIS_MONTH,
        element: (
          <span onClick={this.onChange.bind(this, THIS_MONTH)}>
            This Month
            {this.isChecked(THIS_MONTH) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: LAST_MONTH,
        element: (
          <span onClick={this.onChange.bind(this, LAST_MONTH)}>
            Last Month
            {this.isChecked(LAST_MONTH) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: CUSTOM,
        element: (
          <div className="custom-dates-item">
            <div className="buttons-contianer" style={{ overflow: 'visible' }}>
              <Suspense fallback={<span className="spinner" />}>
                <div className="from-container">
                  <LazyDatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={datePickerFromDay.toDate()}
                    maxDate={fromMaxDate.toDate()}
                    onChange={this.handleFromChange.bind(this)}
                    fixedHeight
                  />
                </div>
                <LazyDatePicker
                  maxDate={toMaxDate.toDate()}
                  minDate={toMinDate.toDate()}
                  dateFormat="dd/MM/yyyy"
                  selected={datePickerToDay.toDate()}
                  onChange={this.handleToChange.bind(this)}
                  fixedHeight
                />
              </Suspense>
            </div>
            <button
              disabled={disableApply}
              className="apply-button"
              onClick={this.onApply.bind(this)}
            >
              Apply
            </button>
          </div>
        )
      }
    ];

    if (period === CUSTOM) {
      customSelected = (
        <div className="calendar-item">
          <Icon name="calendar" className="calendar-icon" />
          {`${datePickerFromDay.format('MMM DD YYYY')} - ${datePickerToDay.format('MMM DD YYYY')}`}
        </div>
      );
    }
    return (
      <div className="dates-selector">
        <Selector
          ref="selector"
          hideOnClick={false}
          items={items}
          selected={period}
          width={240}
          customSelected={customSelected}
        />
      </div>
    );
  }
}

export default DatesSelector;
